import { Subject } from 'rxjs';
export function createAction(operator) {
    const source$ = new Subject();
    const emitter = (event) => source$.next(event);
    emitter.event$ = operator ? source$.pipe(operator) : source$.asObservable();
    return emitter;
}
//# sourceMappingURL=action.js.map